import React, { useState } from "react";
import "../assets/widerruf-preview.css";

const PREVIEW_SAMPLE = {
  firstName: "test",
  lastName: "test",
  email: "test@test.de",
  orderNumber: "#1001"
};

export function WiderrufFormPreview({ texts = {}, localeLabel = "" }) {
  const [previewStep, setPreviewStep] = useState(1);
  const get = (key) => texts[key] ?? "";
  const steps = [1, 2, 3];

  return (
    <div className="widerruf-preview-host">
      <div className="widerruf-preview-host__toolbar" role="tablist" aria-label="Preview step">
        <ol className="widerruf-preview-stepper">
          {steps.map((step, index) => {
            const isActive = previewStep === step;
            const isComplete = previewStep > step;
            const isLast = index === steps.length - 1;

            return (
              <li
                key={step}
                className="widerruf-preview-stepper__step"
                data-status={isComplete ? "complete" : isActive ? "active" : "inactive"}
              >
                <button type="button" onClick={() => setPreviewStep(step)} className="widerruf-preview-stepper__button">
                  <span className="widerruf-preview-stepper__indicator">{step}</span>
                  <span className="widerruf-preview-stepper__title">Step {step}</span>
                </button>
                {!isLast ? <span className="widerruf-preview-stepper__separator" aria-hidden="true" /> : null}
              </li>
            );
          })}
        </ol>
        {localeLabel ? <span className="widerruf-preview-host__locale">{localeLabel}</span> : null}
      </div>

      <div className="widerruf-modal__panel">
        <button type="button" className="widerruf-modal__close" aria-label={get("modal_close") || "Close"} disabled>
          <span aria-hidden="true">&times;</span>
        </button>

        <section className="widerruf-flow widerruf-flow--modal" aria-label={get("steps_nav_label") || "Withdrawal form preview"}>
          <header className="widerruf-flow__header">
            {get("brand_eyebrow") ? <p className="widerruf-flow__eyebrow">{get("brand_eyebrow")}</p> : null}
            <h2 className="widerruf-flow__title">{get("flow_heading")}</h2>
            {get("flow_subtitle") ? <p className="widerruf-flow__subtitle">{get("flow_subtitle")}</p> : null}
          </header>

          <form className="widerruf-wizard" onSubmit={(event) => event.preventDefault()}>
            <nav className="widerruf-steps" aria-label={get("steps_nav_label")}>
              <button type="button" className={`widerruf-step${previewStep === 1 ? " is-active" : ""}`} disabled>
                {get("steps_step_1")}
              </button>
              <button type="button" className={`widerruf-step${previewStep === 2 ? " is-active" : ""}`} disabled>
                {get("steps_step_2")}
              </button>
              <button type="button" className={`widerruf-step${previewStep === 3 ? " is-active" : ""}`} disabled>
                {get("steps_step_3")}
              </button>
            </nav>

            {previewStep === 1 ? (
              <div className="widerruf-screen is-active">
                <h3>{get("steps_step_1_title")}</h3>
                <p className="widerruf-screen__description">{get("steps_step_1_description")}</p>
                <div className="widerruf-grid">
                  <div className="widerruf-field">
                    <label>{get("form_first_name")} *</label>
                    <input type="text" value={PREVIEW_SAMPLE.firstName} readOnly tabIndex={-1} />
                  </div>
                  <div className="widerruf-field">
                    <label>{get("form_last_name")} *</label>
                    <input type="text" value={PREVIEW_SAMPLE.lastName} readOnly tabIndex={-1} />
                  </div>
                </div>
                <div className="widerruf-field">
                  <label>{get("form_email")} *</label>
                  <input type="email" value={PREVIEW_SAMPLE.email} readOnly tabIndex={-1} />
                </div>
                <div className="widerruf-field">
                  <label>
                    {get("form_order_number")} {get("form_order_number_hint")}
                  </label>
                  <input type="text" value={PREVIEW_SAMPLE.orderNumber} readOnly tabIndex={-1} />
                </div>
                <div className="widerruf-actions">
                  <button type="button" className="widerruf-btn widerruf-btn--primary" disabled>
                    {get("actions_next")}
                  </button>
                </div>
              </div>
            ) : null}

            {previewStep === 2 ? (
              <div className="widerruf-screen is-active">
                <h3>{get("steps_step_2_title")}</h3>
                <p className="widerruf-screen__description">{get("steps_step_2_description")}</p>
                <div className="widerruf-card">
                  <strong>
                    {get("form_order_label")} {PREVIEW_SAMPLE.orderNumber}
                  </strong>
                </div>
                <div className="widerruf-field">
                  <label>{get("form_item")}</label>
                  <input type="text" placeholder={get("form_item_placeholder")} readOnly tabIndex={-1} />
                </div>
                <div className="widerruf-grid">
                  <div className="widerruf-field">
                    <label>{get("form_reason")}</label>
                    <select value="" disabled tabIndex={-1}>
                      <option value="">{get("form_reason_placeholder")}</option>
                    </select>
                  </div>
                  <div className="widerruf-field">
                    <label>{get("form_quantity")}</label>
                    <input type="number" value="1" readOnly tabIndex={-1} />
                  </div>
                </div>
                <div className="widerruf-actions">
                  <button type="button" className="widerruf-btn" disabled>
                    {get("actions_back")}
                  </button>
                  <button type="button" className="widerruf-btn widerruf-btn--primary" disabled>
                    {get("actions_next")}
                  </button>
                </div>
              </div>
            ) : null}

            {previewStep === 3 ? (
              <div className="widerruf-screen is-active">
                <h3>{get("steps_step_3_title")}</h3>
                <p className="widerruf-screen__description">{get("steps_step_3_description")}</p>
                <div className="widerruf-summary">
                  <p>
                    <strong>{get("summary_status_label")}</strong> {get("summary_status_value")}
                  </p>
                  <p>
                    <strong>{get("form_email")}:</strong> {PREVIEW_SAMPLE.email}
                  </p>
                  <p>
                    <strong>{get("form_order_number")}:</strong> {PREVIEW_SAMPLE.orderNumber}
                  </p>
                </div>
                <div className="widerruf-actions">
                  <button type="button" className="widerruf-btn" disabled>
                    {get("actions_back")}
                  </button>
                  <button type="submit" className="widerruf-btn widerruf-btn--primary" disabled>
                    {get("form_submit")}
                  </button>
                </div>
              </div>
            ) : null}
          </form>

          <aside className="widerruf-legal-note" aria-label={get("legal_aria_label")}>
            <strong>{get("legal_title")}</strong> {get("legal_body")}
          </aside>
        </section>
      </div>
    </div>
  );
}
